// Author lidongxu
// Date 2023-12-04 15:10:42

class SithMesInventoryComprehensiveBusinessRecord {
    constructor({
                    orderCodeAndOperationIdsList = '',
                    type = '',
                    id = null,
                    vendorName = '',
                    consignor = '',
                    consignorContact = '',
                    consignorContactPhone = '',
                    consignorAddress = '',
                    consignee = '',
                    consigneeContact = '',
                    consigneeContactPhone = '',
                    consigneeAddress = '',
                    specialRequirement = '',
                    weight = '',
                    length = '',
                    width = '',
                    height = '',
                    detailInformation = '',
                    outdoorType = '',
                    category = '',
                    borrower = '',
                    transportType = '',
                    leaveFactoryDate = '',
                    transType = '',
                    transReason = '',
                    requiredTime = '',
                    requirePackage = '',
                    actualTransportQuantity = '',
                    actualTransportWeight = '',
                    frame = '',
                    deliveryType = ''
                }
                        = {}) {
        this.orderCodeAndOperationIdsList = orderCodeAndOperationIdsList;
        this.type = type;
        this.id = id;
        this.vendorName = vendorName;
        this.consignor = consignor;
        this.consignorContact = consignorContact;
        this.consignorContactPhone = consignorContactPhone;
        this.consignorAddress = consignorAddress;
        this.consignee = consignee;
        this.consigneeContact = consigneeContact;
        this.consigneeContactPhone = consigneeContactPhone;
        this.consigneeAddress = consigneeAddress;
        this.specialRequirement = specialRequirement;
        this.weight = weight;
        this.length = length;
        this.width = width;
        this.height = height;
        this.detailInformation = detailInformation;
        this.outdoorType = outdoorType;
        this.category = category;
        this.borrower = borrower;
        this.transportType = transportType;
        this.leaveFactoryDate = leaveFactoryDate;
        this.transType = transType;
        this.transReason = transReason;
        this.requiredTime = requiredTime;
        this.requirePackage = requirePackage;
        this.actualTransportQuantity = actualTransportQuantity;
        this.actualTransportWeight = actualTransportWeight;
        this.frame = frame;
        this.deliveryType = deliveryType;
    }
}

function newEntity() {
    return new SithMesInventoryComprehensiveBusinessRecord();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'businessApplicationNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.businessApplicationNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'outdoorCertiNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.outdoorCertiNo',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transportApplicationNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.transportApplicationNo',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.deliveryNo',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transferTicketNo',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.transferTicketNo',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applicant',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.applicant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCodes',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.projectCodes',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectNames',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.projectNames',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsCodes',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.wbsCodes',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prCodes',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.prCodes',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCodes',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.orderCodes',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.grid.remark',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    businessApplicationNoFilter: '',
    outdoorCertiNoFilter: '',
    transportApplicationNoFilter: '',
    deliveryNoFilter: '',
    transferTicketNoFilter: '',
    createdByFilter: '',
    projectCodeFilter: '',
    projectNameFilter: '',
    wbsCodeFilter: '',
    orderCodeFilter: '',
    prCodeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'businessApplicationNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.businessApplicationNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'outdoorCertiNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.outdoorCertiNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transportApplicationNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.transportApplicationNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transferTicketNoFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.transferTicketNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.createdBy',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.wbsCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.filter.prCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'type',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.id',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorName',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.vendorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignor',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consignor',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignorContact',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consignorContact',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignorContactPhone',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consignorContactPhone',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignorAddress',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consignorAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consignee',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consignee',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeContact',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consigneeContact',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeContactPhone',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consigneeContactPhone',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'consigneeAddress',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.consigneeAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialRequirement',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.specialRequirement',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.weight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.length',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.width',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.height',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'detailInformation',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.detailInformation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'outdoorType',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.outdoorType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '11', text: 'A类-非销售'},
                {value: '12', text: 'B类-销售产成品'},
                {value: '13', text: 'C类-销售非产成品'},
                {value: '14', text: 'D类-汽车运输服务'},
                {value: '15', text: 'E类-汽车吊服务'}
            ]
        }
    },
    {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.category',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryOutdoorProductCategory'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'borrower',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.borrower',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transportType',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.transportType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '专车'},
                {value: '2', text: '零担'},
                {value: '3', text: '加急零担'},
                {value: '4', text: '快递'},
                {value: '5', text: '快递到付'},
                {value: '6', text: '收货方自提'}
            ]
        }
    },
    {
        key: 'leaveFactoryDate',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.leaveFactoryDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transType',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.transType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内对外'},
                {value: '2', text: '内对内'},
                {value: '3', text: '汽车吊'},
                {value: '4', text: '外对外'},
                {value: '5', text: '外对内'}
            ]
        }
    },
    {
        key: 'transReason',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.transReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredTime',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.requiredTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirePackage',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.requirePackage',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualTransportQuantity',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.actualTransportQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualTransportWeight',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.actualTransportWeight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'frame',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.frame',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '框架内'},
                {value: '2', text: '框架外'}
            ]
        }
    },
    {
        key: 'deliveryType',
        label: 'label.sith.inventory.sithMesInventoryComprehensiveBusinessRecord.entity.deliveryType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产终检转交'},
                {value: '2', text: '800工单转交'},
                {value: '3', text: 'DN400点件转交'},
                {value: '4', text: '其他转交'}
            ]
        }
    }
]

export {
    SithMesInventoryComprehensiveBusinessRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
